export default __webpack_public_path__ + "static/media/logo.bd8b7398.png";